import { createContext, useContext } from 'react';
const AcademyChatActionsContext = /*#__PURE__*/createContext(null);
export const AcademyChatActionsProvider = AcademyChatActionsContext.Provider;
export const useAcademyChatActions = () => {
  const context = useContext(AcademyChatActionsContext);
  if (!context) {
    throw new Error('useAcademyChatActions must be used within an AcademyChatActionsProvider');
  }
  return context;
};